import React, { FunctionComponent } from "react";
import {
    StatusMessageContainer,
    StatusMessageDescription,
    StatusMessageTitle,
    StatusIcon,
} from "./style";
import "external-svg-loader";
import config from "../../config/enviroment";
import { language } from "../../utils/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import ErrorStatusIcon from "./ErrorStatusIcon";
import SuccessStatusIcon from "./SuccessStatusIcon";

type StatusMessageProps = {
    status: "success" | "pending" | "error",
    color: string
};




const StatusMessage: FunctionComponent<StatusMessageProps> = ({ status, color }) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    const displayInformation = {
        success: {
            title:  language[homeState.default_language]["sucessPay"],
            message:  language[homeState.default_language]["messageSucessPay"],
            icon: <SuccessStatusIcon />
        },
        pending: {
            title:  language[homeState.default_language]["pendingPay"],
            message:  language[homeState.default_language]["messagePendingPay"],
            icon: <svg data-src={`${config.urlMultimedia}/vende/landing-img/pending.svg`}/>
        },
        error:  {
            title:  language[homeState.default_language]["rejectPay"],
            message:  language[homeState.default_language]["messageRejectPay"],
            icon: <ErrorStatusIcon />
        },
    };

    return (
        <StatusMessageContainer $status={status}>
            <StatusIcon color={color} $status={status}>
                {displayInformation[status].icon}
            </StatusIcon>
            <StatusMessageTitle $status={status}>{displayInformation[status].title}</StatusMessageTitle>
            <StatusMessageDescription $status={status}>{displayInformation[status].message}</StatusMessageDescription>
        </StatusMessageContainer>
    );
};

export default StatusMessage;
